module.exports = __webpack_public_path__ + "static/media/parliment.10c46cb2.gif";